declare global {
  interface Window {
    __layerConfig: {
      AUTH0_CLIENT_ID: string;
      AUTH0_DOMAIN: string;
      AUTH0_AUDIENCE: string;
      IS_PRODUCTION: boolean;
      SUBDOMAIN: string;
      FILES_URL: string;
      BUCKET_NAME: string;
    };
  }
}
export interface LayerConfig {
  AUTH0_DOMAIN: string;
  AUTH0_CLIENT_ID: string;
  AUTH0_AUDIENCE: string;
  IS_PRODUCTION: boolean;
  SUBDOMAIN: string;
  // Media origin and GCS bucket as resolved by the backend. Consumed directly
  // instead of rebuilt from SUBDOMAIN, so local/personal stacks (e.g.
  // storage.googleapis.com/layer-files-gcp-dev-<name>) resolve correctly.
  FILES_URL: string;
  BUCKET_NAME: string;
}

const defaultConfig: LayerConfig = {
  AUTH0_DOMAIN: "",
  AUTH0_CLIENT_ID: "",
  AUTH0_AUDIENCE: "",
  IS_PRODUCTION: false,
  SUBDOMAIN: "dev",
  FILES_URL: "https://media.dev.layer.ai",
  BUCKET_NAME: "layer-stack-gcp-dev",
};

const layerConfig = window.__layerConfig || defaultConfig;

export const layerBaseUrl = `https://${layerConfig.SUBDOMAIN}.layer.ai`;
// The public site, which production serves at the apex rather than on the app subdomain.
export const siteBaseUrl = layerConfig.IS_PRODUCTION
  ? "https://layer.ai"
  : `https://${layerConfig.SUBDOMAIN}.layer.ai`;
export const filesBaseUrl = layerConfig.FILES_URL;
export const bucketBaseUrl = `https://console.cloud.google.com/storage/browser/_details/${layerConfig.BUCKET_NAME}`;
export const auth0BaseUrl = `https://manage.auth0.com/dashboard/eu/layer-stack-${layerConfig.SUBDOMAIN}`;
export const baseStripeUrl = `https://dashboard.stripe.com${
  layerConfig.IS_PRODUCTION ? "" : "/test"
}`;
export const temporalUiBaseUrl = `https://web.temporal.${layerConfig.SUBDOMAIN}.layer.co`;
export default layerConfig;
